import type { IResource, ResourceType } from "@gettactic/api";
import { canGainDedicatedSeats } from "@gettactic/helpers/src/resources/dedicatedSeats";

/**
 * The type and slot count a General save sends. A dedicated desk or workspace
 * takes them from the form, so an admin can size a shared workspace for its
 * owners. Any other dedicated resource hides those fields, so its stored
 * values are kept. Core refuses a size below the owner count with
 * `capacity_below_dedicated_users`.
 */
export const capacityRequestFields = (
  resource: Pick<IResource, "type" | "total_slots" | "is_dedicated">,
  formType: ResourceType,
  values: { isMultiple: boolean; totalSlots: number; isMeetingRoom: boolean }
): { type: ResourceType; total_slots: number } => {
  if (resource.is_dedicated && !canGainDedicatedSeats(resource.type)) {
    return { type: resource.type, total_slots: resource.total_slots };
  }
  if (resource.type === "area") {
    return { type: formType, total_slots: resource.total_slots };
  }
  return {
    type: formType,
    total_slots:
      values.isMultiple || values.isMeetingRoom ? values.totalSlots : 1
  };
};
